import { Action } from '@ngrx/store';

export enum ActionTypes {
  LOAD_COMPONENT = '[Order Subscription Component] Load Component',
  LOAD_ORDER_DETAIL_COMPONENT = '[Order Subscription Component] Load Order Detail Component',
  LOAD_ORDER_SUMMARY_COMPONENT = '[Order Subscription Component] Load Order Summary Component',
  LOAD_ORDER_REPEAT_COMPONENT = '[Order Subscription Component] Load Order Repeat Component',
  LOAD_ORDER_MODIFY_COMPONENT = '[Order Subscription Component] Load Order Modify Component',
  LOAD_FAILURE = '[Order Subscription Component] Load Failure',
  ENABLE_COMPONENT = '[Order Subscription Component] Enable Component',
  DISABLE_COMPONENT = '[Order Subscription Component] Disable Component',
  FETCH_DESTINATIONS = '[Order Subscription Component] Fetch Destinations',
  FETCH_DESTINATIONS_SUCCESS = '[Order Subscription Component] Fetch Destinations Success',
  FETCH_DESTINATIONS_FAILURE = '[Order Subscription Component] Fetch Destinations Failure',
  PATCH_DESTINATIONS = '[Order Subscription Component] Patch Destinations',
  PATCH_DESTINATIONS_SUCCESS = '[Order Subscription Component] Patch Destinations Success',
  PATCH_DESTINATIONS_FAILURE = '[Order Subscription Component] Patch Destinations Failure',
  TRIGGER_SUBSCRIPTION_CHECK = '[Order Subscription Component] Check trigger subscription',
  SHOW_DISCARD_MODAL = '[Order Subscription Component] show discard modal',
  RESET = '[Order Subscription Component] Reset',
  // MOO
  LOAD_ORDERS_MOO_SUMMARY_COMPONENT = '[Order Subscription Component] Load Order MOO Component',
  ENABLE_COMPONENT_MOO = '[Order Subscription Component] Enable Component from MOO',
  DISABLE_COMPONENT_MOO = '[Order Subscription Component] Disable Component from MOO',
  FETCH_DESTINATIONS_MOO = '[Order Subscription Component] Fetch Destinations from MOO',
  FETCH_DESTINATIONS_MOO_SUCCESS = '[Order Subscription Component] Fetch Destinations MOO Success',
  DISABLE_NOTIFICATIONS = '[Order Subscription Component] Disable Notifications MOO Success',
  PATCH_DESTINATIONS_MOO = '[Order Subscription Component] Patch Destinations from MOO',
  PATCH_DESTINATIONS_MOO_SUCCESS = '[Order Subscription Component] Patch Destinations MOO Success',
  PATCH_DESTINATIONS_MOO_FAILURE = '[Order Subscription Component] Patch Destinations MOO Failure',

}

export class LoadComponentAction implements Action {
  readonly type = ActionTypes.LOAD_COMPONENT;
  constructor(public payload: string) { }
}

export class LoadOrderDetailComponentAction implements Action {
  readonly type = ActionTypes.LOAD_ORDER_DETAIL_COMPONENT;
  constructor() { }
}

export class LoadOrderSummaryComponentAction implements Action {
  readonly type = ActionTypes.LOAD_ORDER_SUMMARY_COMPONENT;
  constructor() { }
}

export class LoadOrderRepeatComponentAction implements Action {
  readonly type = ActionTypes.LOAD_ORDER_REPEAT_COMPONENT;
  constructor() { }
}

export class LoadOrderModifyComponentAction implements Action {
  readonly type = ActionTypes.LOAD_ORDER_MODIFY_COMPONENT;
  constructor() { }
}

export class LoadFailureAction implements Action {
  readonly type = ActionTypes.LOAD_FAILURE;
  constructor() { }
}

export class EnableComponentAction implements Action {
  readonly type = ActionTypes.ENABLE_COMPONENT;
  constructor(public payload: { orderId: number; checked: boolean; discardDefaultInformation?: boolean }) {}
}

export class DisableComponentAction implements Action {
  readonly type = ActionTypes.DISABLE_COMPONENT;
  constructor() { }
}

export class FetchDestinationsAction implements Action {
  readonly type = ActionTypes.FETCH_DESTINATIONS;
  constructor(public payload: { orderId: number; checked: boolean; discardDefaultInformation?: boolean }) {}
}

export class FetchDestinationsSuccessAction implements Action {
  readonly type = ActionTypes.FETCH_DESTINATIONS_SUCCESS;
  constructor(
    public payload: {
      emailSubscribed: boolean;
      phoneSubscribed: boolean;
      emails: string[];
      phones: string[];
      canDeleteFirstElement: boolean;
      phoneCode: string;
    },
  ) {}
}

export class FetchDestinationsFailureAction implements Action {
  readonly type = ActionTypes.FETCH_DESTINATIONS_FAILURE;
  constructor() { }
}

export class PatchDestinationsAction implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS;
  constructor(
    public payload: {
      emailSubscribed: boolean;
      phoneSubscribed: boolean;
      emails: string[];
      phones: string[];
      type: string;
      phoneCode: string;
    },
  ) {}
}

export class PatchDestinationsSuccessAction implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS_SUCCESS;
  constructor(
    public payload: { emailSubscribed: boolean; phoneSubscribed: boolean; emails: string[]; phones: string[] },
  ) {}
}

export class PatchDestinationsFailureAction implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS_FAILURE;
  constructor() { }
}

export class TriggerSubscriptionCheckAction implements Action {
  readonly type = ActionTypes.TRIGGER_SUBSCRIPTION_CHECK;
  constructor(public payload: boolean) { }
}

export class ShowDiscardModal implements Action {
  readonly type = ActionTypes.SHOW_DISCARD_MODAL;
  constructor(public payload: { showDiscardModal: boolean }) { }
}

export class OrderSubscriptionResetAction implements Action {
  readonly type = ActionTypes.RESET;

  constructor() {}
}



// MOO
export class LoadOrdersMOOSummaryComponentAction implements Action {
  readonly type = ActionTypes.LOAD_ORDERS_MOO_SUMMARY_COMPONENT;
  constructor() { }
}

export class EnableComponentMOOAction implements Action {
  readonly type = ActionTypes.ENABLE_COMPONENT_MOO;
  constructor(public payload: { groupId: number; checked: boolean; discardDefaultInformation?: boolean }) {}
}


export class DisableComponentMOOAction implements Action {
  readonly type = ActionTypes.DISABLE_COMPONENT_MOO;
  constructor() {}
}

export class FetchDestinationsMOOAction implements Action {
  readonly type = ActionTypes.FETCH_DESTINATIONS_MOO;
  constructor(public payload: { groupId: number; checked: boolean; discardDefaultInformation?: boolean }) {}
}

export class DisabledNotificationsSuccessAction implements Action {
  readonly type = ActionTypes.DISABLE_NOTIFICATIONS;
  constructor() {}
}

export class FetchDestinationsMOOSuccessAction implements Action {
  readonly type = ActionTypes.FETCH_DESTINATIONS_MOO_SUCCESS;
  constructor(
    public payload: {
      emailSubscribed: boolean;
      phoneSubscribed: boolean;
      emails: string[];
      phones: string[];
      canDeleteFirstElement: boolean;
      phoneCode: string;
    },
  ) {}
}

export class PatchDestinationsActionMOO implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS_MOO;
  constructor(
    public payload: {
      emailSubscribed: boolean;
      phoneSubscribed: boolean;
      emails: string[];
      phones: string[];
      type: string;
      phoneCode: string;
    },
  ) {}
}

export class PatchDestinationsSuccessActionMOO implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS_MOO_SUCCESS;
  constructor(
    public payload: { emailSubscribed: boolean; phoneSubscribed: boolean; emails: string[]; phones: string[] },
  ) {}
}

export class PatchDestinationsFailureActionMOO implements Action {
  readonly type = ActionTypes.PATCH_DESTINATIONS_MOO_FAILURE;
  constructor() { }
}

export type Actions =
  | LoadComponentAction
  | LoadOrderSummaryComponentAction
  | LoadOrderDetailComponentAction
  | LoadOrderRepeatComponentAction
  | LoadOrderModifyComponentAction
  | LoadFailureAction
  | EnableComponentAction
  | DisableComponentAction
  | FetchDestinationsAction
  | FetchDestinationsSuccessAction
  | FetchDestinationsFailureAction
  | PatchDestinationsAction
  | PatchDestinationsSuccessAction
  | PatchDestinationsFailureAction
  | TriggerSubscriptionCheckAction
  | ShowDiscardModal
  | OrderSubscriptionResetAction
  | LoadOrdersMOOSummaryComponentAction
  | EnableComponentMOOAction
  | FetchDestinationsMOOAction
  | FetchDestinationsMOOSuccessAction
  | DisableComponentMOOAction
  | DisabledNotificationsSuccessAction
  | PatchDestinationsActionMOO
  | PatchDestinationsSuccessActionMOO
  | PatchDestinationsFailureActionMOO
  ;
